import React from "react";
import "../styles/SkeletonCard.scss";

const SkeletonCard = () => {
  return (
    <div className="sk-main-container">
      <div className="sk-line sk-line-title"></div>
      <div className="sk-line sk-line-subtitle"></div>
      <div className="sk-spacer"></div>
      <div className="sk-line sk-line-delta"></div>
      <div className="sk-line sk-line-value"></div>
    </div>
  );
};

export default SkeletonCard;
